import React from 'react'
import { Box, Button, Stack, Tooltip, Typography } from '@mui/material'

import { DARK_TOOLTIP_PROPS, SMOOTH_ICON_SX } from './styles'

export const Widget = ({ icon, title, action, children, sx }) => {
  const hasHeader = Boolean(icon || title || action)

  return (
    <Box
      sx={{
        border: '1px solid #EFEFEF',
        borderRadius: '24px',
        backgroundColor: '#fff',
        minHeight: 300,
        p: 2.5,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        ...sx
      }}
    >
      {hasHeader && (
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2} mb={2}>
          <Stack direction="row" alignItems="center" gap={1}>
            {icon && (
              <Box
                component="span"
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  backgroundColor: '#3D3D3D',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  overflow: 'hidden'
                }}
              >
                <Box component="i" className={icon} sx={{ fontSize: 12, ...SMOOTH_ICON_SX }} />
              </Box>
            )}
            {title && <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#464646' }}>{title}</Typography>}
          </Stack>
          {action}
        </Stack>
      )}
      {children}
    </Box>
  )
}

export const SoftButton = ({ children, icon, onClick, disabled, tooltip, fullWidthOnMobile = false }) => {
  const width = fullWidthOnMobile ? { xs: '100%', md: 'max-content' } : 'max-content'
  const button = (
    <Button
      onClick={onClick}
      disabled={disabled}
      sx={{
        height: 24,
        minHeight: 24,
        maxHeight: 24,
        minWidth: 0,
        width,
        px: 1.25,
        border: '1px solid #E4EEFA',
        backgroundColor: '#F2F8FD',
        color: '#2570EB',
        borderRadius: '8px',
        fontSize: 10,
        fontWeight: 500,
        textTransform: 'none',
        whiteSpace: 'nowrap',
        '&:hover': { backgroundColor: '#E4EEFA' },
        '&.Mui-disabled': {
          color: '#8AB5F2',
          borderColor: '#E4EEFA',
          backgroundColor: '#F2F8FD'
        }
      }}
    >
      {icon && <Box component="i" className={icon} sx={{ fontSize: 10, mr: 0.75 }} />}
      {children}
    </Button>
  )

  return tooltip ? (
    <Tooltip title={tooltip} arrow {...DARK_TOOLTIP_PROPS}>
      <Box component="span" sx={{ display: 'inline-flex', width }}>{button}</Box>
    </Tooltip>
  ) : button
}

export const InfoRow = ({ label, value, sx, dividerSx }) => (
  <Stack direction="row" alignItems="center" gap={1} sx={{ minHeight: 28, ...sx }}>
    <Typography sx={{ fontSize: 12, fontWeight: 400, color: '#464646', whiteSpace: 'nowrap' }}>{label}</Typography>
    <Box sx={{ flex: 1, height: '1px', backgroundColor: '#F7F7F7', ...dividerSx }} />
    <Typography sx={{ fontSize: 12, fontWeight: 500, color: '#656565', textAlign: 'right', overflowWrap: 'anywhere' }}>
      {value || '-'}
    </Typography>
  </Stack>
)

export const DetailCardGrid = ({ children, sx }) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' }, gap: 2, ...sx }}>
    {children}
  </Box>
)
